<template>
  <div class="containerBox" ref="box">
    <!--  顶部导航  -->
    <nav-bar />
    <div class="box">
      <div class="boxContent">
        <div class="boxContent_left" v-scroll-reveal="{origin: 'left'}">
          <div class="boxContent_left_item" v-for="(item, index) in modelData" :key="index">
            <div class="boxContent_left_item_left">
              <img :src="item.icon" alt="">
              <span>{{ item.name }}</span>
            </div>
            <div class="boxContent_left_item_right">
              <div v-for="(item1, index1) in item.children" :key="index1" :class="{boxContent_left_item_right_a: modelIndex1 === index && modelIndex2 === index1}" @click="choseItem(index, index1)">{{ item1.name }}</div>
<!--              <div>司机端</div>-->
            </div>
          </div>
        </div>
        <div class="boxContent_center" v-scroll-reveal>
          <img :src="modelData[modelIndex1].children[modelIndex2].imgSrc" alt="">
        </div>
        <div class="boxContent_right" v-scroll-reveal="{origin: 'right'}">
          <div class="boxContent_right_title">{{ modelData[modelIndex1].children[modelIndex2].title }}</div>
          <p class="boxContent_right_content" style="margin-top: 40px;">整车零担秒接单 货运流程变简单</p>
          <p class="boxContent_right_content">一手货源就来货满满 专业的智能货运平台</p>
          <div class="boxContent_right_qr">
            <img :src="modelData[modelIndex1].children[modelIndex2].qrImg" alt="">
            <p>扫码下载货满满App</p>
          </div>
        </div>
      </div>
    </div>
    <!--  底部  -->
    <bottom-footer/>
  </div>
</template>

<script>
import NavBar from '@/components/nav-bar.vue'
import BottomFooter from '@/components/bottom-footer.vue'
export default {
  name: "DownLoad",
  components: {
    NavBar,
    BottomFooter,
  },
  data() {
    return {
      modelIndex1: 0, // 第一层数据
      modelIndex2: 0, // 第二层数据
      modelData: [
        {
          id: 1,
          name: '安卓',
          icon: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/download/anzhuo.png',
          children: [
            {
              title: '货满满货主端',
              name: '货主端',
              imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/download/hz.png',
              qrImg: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/a_hz.png'
            },
            {
              title: '货满满司机端',
              name: '司机端',
              imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/download/sj.png',
              qrImg: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/a_sj.png'
            }
          ]
        },
        {
          id: 2,
          name: 'ios',
          icon: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/download/ios.png',
          children: [
            {
              title: '货满满货主端',
              name: '货主端',
              imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/download/hz.png',
              qrImg: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/i_hz4.png'
            },
            {
              title: '货满满司机端',
              name: '司机端',
              imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/download/sj.png',
              qrImg: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/i_sj.png',
            }
          ]
        },
        {
          id: 3,
          name: '小程序',
          icon: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/download/xcx.png',
          children: [
            {
              title: '货满满货主端',
              name: '货主端',
              imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/download/hz.png',
              qrImg: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/aboutus/wxminCode.jpg',
            }
          ]
        },
        {
          id: 4,
          name: '公众号',
          icon: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/download/gongzhonghao.png',
          children: [
            {
              title: '微信公众号',
              name: '微信公众号',
              imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/download/gzh.png',
              qrImg: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/aboutus/gzh.jpg',
            }
          ]
        }
      ]
    }
  },
  methods: {
    choseItem(index1, index2) {
      this.modelIndex1 = index1
      this.modelIndex2 = index2
    }
  },
}
</script>

<style lang="scss" scoped>
.box{
  height: 837px;
  width: 100%;
  background: url('https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/bg/download_bg.png') no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}
.boxContent{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 1200px;
  //height: 100%;
  margin: 141px auto 0;
  .boxContent_left{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 445px;
    .boxContent_left_item{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      margin-top: 50px;
      .boxContent_left_item_left{
        width: 142px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: rgba(255,255,255,0.80);
        line-height: 28px;
       & > img{
         display: block;
         width: 24px;
         height: 24px;
         margin-right: 16px;
        }
      }
      .boxContent_left_item_right{
        &>div{
          font-size: 20px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: LEFT;
          color: #ffffff;
          line-height: 28px;
          margin-bottom: 26px;
          cursor: pointer;
        }
        .boxContent_left_item_right_a{
          font-size: 26px;
          line-height: 36px;
          margin-bottom: 16px;
          border-bottom: 2px solid #FFFFFF;
        }
      }
    }
  }
  .boxContent_center{
    height: 520px;
    width: 258px;
    margin-right: 100px;
    &>img{
      width: 100%;
      height: 100%;
    }
  }
  .boxContent_right{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .boxContent_right_title{
      font-size: 40px;
      font-family: PingFang SC, PingFang SC-Bold;
      font-weight: 700;
      text-align: LEFT;
      color: #ffffff;
      line-height: 56px;
    }
    .boxContent_right_content{
      font-size: 20px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      text-align: LEFT;
      color: #ffffff;
      line-height: 28px;
      margin-top: 10px;
    }
    .boxContent_right_qr{
      width: 165px;
      height: 192px;
      background: #ffffff;
      border-radius: 10px;
      padding: 10px;
      margin-top: 42px;
      box-sizing: border-box;
      img{
        display: block;
        width: 145px;
        height: 145px;
      }
      p{
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: center;
        color: #333333;
        line-height: 17px;
        margin-top: 10px;
      }
    }
  }
}
</style>